import type { NuxtLocale } from '~/constants/locales'
import type { Configuration } from '~/types/configurator'

export default function useConfigurationFetcher() {
  const configuratorRepo = createConfiguratorRepository()
  const { locale } = useI18n()

  const userStore = useUser()
  const { userCustomerGroupId } = storeToRefs(userStore)
  const userConfigStore = useUserConfig()
  const { customerGroupId, priceCategoryId } = storeToRefs(userConfigStore)

  const commonParams = computed(() => {
    return {
      language: convertNuxtLocale(locale.value as NuxtLocale),
      ...((customerGroupId.value || userCustomerGroupId.value) && {
        customerGroupNid: customerGroupId.value ?? userCustomerGroupId.value,
      }),
      ...(priceCategoryId.value && {
        priceCategoryNid: priceCategoryId.value,
      }),
    }
  })

  function getUserConfigurationBySlug(slug: string) {
    return configuratorRepo.getUserConfigurationBySlug(slug, {
      ...commonParams.value,
    })
  }

  function getPreConfigured(
    productNid: number,
    configurationNid?: number | null
  ) {
    return configuratorRepo.getPreConfigured(productNid, {
      ...commonParams.value,
      ...(configurationNid && {
        configurationNid: configurationNid,
      }),
    })
  }

  function getOptions(
    productNid: number,
    currentValues: Configuration['values'],
    newValue?: {
      partCategoryTranslationOfNid: number
      metaAttributeTranslationOfNid: number
    }
  ) {
    return configuratorRepo.getOptions(
      {
        values: currentValues,
        changeVector: newValue ? [newValue] : [],
      },
      {
        ...commonParams.value,
        productNid: productNid,
      }
    )
  }

  function getConfiguration3d(
    productNid: number,
    currentValues: Configuration['values']
  ) {
    return configuratorRepo.getConfiguration3d(
      {
        values: currentValues,
      },
      productNid
    )
  }

  return {
    getUserConfigurationBySlug,
    getPreConfigured,
    getOptions,
    getConfiguration3d,
  }
}
